import { useState, useEffect } from "react";
import firebase from "firebase/app";
import { auth } from "./firebase";

// Only this account may write to the blog (create/edit/delete trips & entries).
// Keep in sync with the `trips` rule in firestore.rules.
export const ADMIN_EMAIL = "granlundsebastian7@gmail.com";

export function isAdmin(user: firebase.User | null): boolean {
  return !!user && user.email?.toLowerCase() === ADMIN_EMAIL;
}

export function useAuth() {
  const [user, setUser] = useState<firebase.User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return auth.onAuthStateChanged((u) => {
      setUser(u);
      setLoading(false);
    });
  }, []);

  return { user, loading, isAdmin: isAdmin(user) };
}
